/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum VaultState {
  Ready = 'Ready',
  InPreparation = 'InPreparation',
  PreparationDelayedDueToExhaustedUserQuota = 'PreparationDelayedDueToExhaustedUserQuota'
}
